export const colors = {
  orange: '#FFB242',
  teal: '#03C0A2',
  blue: '#00ABED',
  pink: '#FF4B93',
  navy: '#050E45',
  purple: '#6C63FF',
  lightPurple: '#9898FF',
  lightestPurple: '#EAEAFF',
} as const;
